import { useState } from 'react';
import ShortsModal from './ShortsModal';

/**
 * 링크가 여러 개일 수 있어 행 전체를 <a> 로 감싸지 않는다 (중첩 앵커는 잘못된 마크업).
 * 제목이 대표 링크이고, 나머지는 아래 줄에 나란히 둔다.
 */
export default function ProjectRow({ project, index }) {
  const { name, desc, status, statusType, image, links, shortId } = project;
  const primary = links[0];
  const [playing, setPlaying] = useState(false);

  return (
    <article className="lw-row">
      <div className="lw-row__media">
        {image ? (
          <img
            src={image}
            alt={`${name} 화면`}
            width="960"
            height="600"
            loading="lazy"
            decoding="async"
          />
        ) : (
          `[${name} 스크린샷]`
        )}

        {shortId && (
          <button
            className="lw-play"
            onClick={() => setPlaying(true)}
            aria-label={`${name} 쇼츠 재생`}
          >
            <svg width="16" height="18" viewBox="0 0 16 18" aria-hidden="true">
              <path d="M2 1.5 L14.5 9 L2 16.5 Z" fill="currentColor" />
            </svg>
          </button>
        )}
      </div>

      <div className="lw-row__body">
        <div className="lw-row__meta">
          <span>{index}</span>
          <span className={`lw-status lw-status--${statusType}`}>
            <span className="lw-status__dot" aria-hidden="true" />
            {status}
          </span>
        </div>

        <h3 className="lw-row__title">
          <a href={primary.href} target="_blank" rel="noreferrer">{name}</a>
        </h3>

        <p className="lw-row__desc">{desc}</p>

        <p className="lw-row__links">
          {links.map((l, i) => (
            <span key={l.href}>
              <a className="lw-arrow" href={l.href} target="_blank" rel="noreferrer">
                {l.label} ↗
              </a>
              {/* 구분점을 앞 항목에 붙여야 줄바꿈될 때 줄 머리에 오지 않는다 */}
              {i < links.length - 1 && (
                <span className="lw-row__sep" aria-hidden="true">·</span>
              )}
            </span>
          ))}
        </p>
      </div>

      {playing && (
        <ShortsModal videoId={shortId} title={name} onClose={() => setPlaying(false)} />
      )}
    </article>
  );
}
